import { NextPage } from 'next'
import { ReactElement } from 'react'

import { ErrorPage } from '~/components/pages'

const FourOhFourPage: NextPage = (): ReactElement => {
	return <ErrorPage errorStatus={404} reason={'Page not found'} />
}

export default FourOhFourPage
